import React from 'react'
import { connect } from 'react-redux'
import { showingCframeModalCheckout, getCframeModalCheckoutProduct, getCframeModalCheckoutQty } from '../../../store/ui/reducers'
import { closeCframeModalCheckout } from '../../../store/ui/actions'
import ComplementaryProductCframe from './ComplementaryProductCframe'
import { fetchCart } from '../../../store/cart/actions'
import { getError } from '../../../store/products/reducers'
import { getLanguage } from '../../../store/ui/reducers'

const mapStateToProps = state => ({
    show: showingCframeModalCheckout(state),
    cframeProduct: getCframeModalCheckoutProduct(state),
    cframeQty: getCframeModalCheckoutQty(state),
    cframeProductError: getError(state),
    language: getLanguage(state),
})

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeCframeModalCheckout())
        dispatch(fetchCart())
    }
})

const ComplementaryProductCframeCheckout = ({ show, cframeProduct, cframeQty, cframeProductError, onClose, language }) => {
    if (!show) return null
    return (
        <ComplementaryProductCframe
            cframeProduct={cframeProduct}
            cframeQty={cframeQty}
            cframeProductError={cframeProductError}
            onClose={onClose}
            language={language}
        />
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(ComplementaryProductCframeCheckout)